import { eachDayOfInterval, format } from 'date-fns'

export const generateDateRange = (startDate, endDate, formatPattern = 'yyyy-MM-dd') => {
  const dates = eachDayOfInterval({
    start: new Date(startDate),
    end: new Date(endDate)
  })

  return dates.map(date => format(date, formatPattern))
}
